import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { CaseStudyEntry } from '@contentful/getCaseStudies';
import { useCaseStudies } from '@hooks/data/useCaseStudies';
import { CaseStudyContext } from './MainContextService';

export const CaseStudiesProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [caseStudies, setCaseStudies] = useState<CaseStudyEntry[] | null>(null);

    const { data } = useCaseStudies();

    useEffect(() => {
        if (data && !caseStudies) {
            setCaseStudies(data);
        }
    }, [data, caseStudies]);

    const contextValue = useMemo(
        () => ({
            caseStudies: caseStudies,
        }),
        [caseStudies],
    );

    return <CaseStudyContext.Provider value={contextValue}>{children}</CaseStudyContext.Provider>;
};
